import { Form, Button, Toast, Mask } from 'antd-mobile'
import { ReactElement, useEffect, useMemo, useRef, useState } from 'react'
import style from './index.module.less'
import { ItemSchema, submitRequest, getDetailRequest, getConfigRequest, getInfoRequest, InfoSchema } from './ajax'
import { awaitWrap } from '@src/assets/js/tool'
import Item from './components/item'
import { FileSchema } from '@src/components/schema/operateSchema'
import type { ToastHandler } from 'antd-mobile/es/components/toast'
import { useParams } from 'react-router-dom'
import titlepic from '@imgs/title.jpg'

async function sumbitHandle (arbitratorid: string, configid: string, items: ItemSchema[], setVersion: (v: number) => void): Promise<void> {
  Toast.show({ content: '提交中', icon: 'loading', duration: 0 })
  const formData = {
    arbitratorid,
    registration_configid: configid,
    items
  }
  formData.items.forEach(li => {
    li.options.forEach(o => {
      o.config_item_groupid = li.config_item_groupid
    })
  })
  const [e] = await awaitWrap(submitRequest(formData))
  if (e === null) {
    Toast.show('提交成功')
    setVersion(Date.now())
  }
}

async function initDetail (
  configid: string,
  setItems: (v: ItemSchema[]) => void,
  setFile: (v: FileSchema) => void,
  setBottomFile: (v: FileSchema) => void,
  setLoading: (v: boolean) => void,
  setFileLoading: (v: boolean) => void,
  setBottomFileLoading: (v: boolean) => void
): Promise<void> {
  setLoading(true)
  const [e, d] = await awaitWrap(getDetailRequest(configid))
  setLoading(false)
  if (e === null && d !== null) {
    setItems(d.items)
    if (d.file !== null && d.file instanceof Array && d.file.length > 0) {
      setFile(d.file[0])
    } else {
      setFileLoading(false)
    }
    if (d.bottom_file !== null && d.bottom_file instanceof Array && d.bottom_file.length > 0) {
      setBottomFile(d.bottom_file[0])
    } else {
      setBottomFileLoading(false)
    }
  }
}

async function initConfig (idno: string, configKey: string, setConfigid: (v: string) => void, setArbitratorid: (v: string) => void, errCallback: () => void): Promise<void> {
  const [e, d] = await awaitWrap(getConfigRequest(idno, configKey))
  if (e === null && d !== null) {
    if (d.configid === null || d.configid === '') {
      errCallback()
      Toast.show({ content: '获取配置失败', duration: 1500, icon: 'fail' })
    }
    setConfigid(d.configid)
    setArbitratorid(d.arbitratorid)
  }
}

function validateFn (list: ItemSchema[]): boolean {
  for (let i = 0; i < list.length; i++) {
    const li = list[i]
    const opts = li.options
    const noChecked = opts.every(o => o.checked === 0)
    if (noChecked) {
      Toast.show(`${li.title}不能为空`)
      return false
    }
    for (let j = 0; j < opts.length; j++) {
      const o = opts[j]
      if (o.checked === 1 && (o.isext === 1 || (li.type === '填空' && li.required === 1)) && (o.result === '' || o.result === null || o.result === undefined)) {
        Toast.show(`${li.title}不能为空`)
        return false
      }
    }
  }
  return true
}

function formatData (d: { items: ItemSchema[] }): void {
  d.items.forEach(li => {
    (li.options.length > 0 ? li.options : []).forEach(o => {
      o.checked = o.checked === true ? 1 : 0
    })
  })
}

async function initInfo (idno: string, confgiKey: string, setIscheck: (v: boolean) => void, setInfo: (v: InfoSchema[]) => void, callback: () => void): Promise<void> {
  const [e, d] = await awaitWrap(getInfoRequest(idno, confgiKey))
  if (e === null && d !== null) {
    setIscheck(d.ischeck === 1)
    if (d.data !== null && d.data instanceof Array) {
      d.data.sort((a, b) => a.orderno - b.orderno)
      setInfo(d.data)
    }
    callback()
  }
}

function formatLabel (s: string): ReactElement {
  if (typeof s !== 'string') {
    return <span />
  }
  const hasSplit = s.includes('\\n')
  if (!hasSplit) {
    return <span>{s}</span>
  }
  const l = s.split('\\n').map((li, i) => {
    if (i === 0) {
      return li.replace(':', '').replace('：', '')
    }
    return li
  })
  return (
    <>
      {l.map((li, i) => {
        return <span key={i}>{li}<br /></span>
      })}
    </>
  )
}

function Main (): ReactElement {
  const [form] = Form.useForm()
  const { idno, configkey } = useParams<{ idno: string, configkey: string }>()
  const [configid, setConfigid] = useState('')
  const [arbitratorid, setArbitratorid] = useState('')
  const [items, setItems] = useState<ItemSchema[]>([])
  const [file, setFile] = useState<FileSchema | null>(null)
  const [bottomfile, setBottomFile] = useState<FileSchema | null>(null)
  const [fileLoading, setFileLoading] = useState(true)
  const [bottomFileLoading, setBottomFileLoading] = useState(true)
  const [detailLoading, setDetailLoading] = useState(true)
  const [ischeck, setIscheck] = useState(true)
  const [info, setInfo] = useState<InfoSchema[]>([])
  const [version, setVersion] = useState(Date.now())
  const loading = useMemo(() => {
    return fileLoading || detailLoading || bottomFileLoading
  }, [fileLoading, detailLoading, bottomFileLoading])
  const handler = useRef<ToastHandler>()
  useEffect(() => {
    if (loading) {
      handler.current = Toast.show({ icon: 'loading', content: '加载中', duration: 0 })
    } else {
      if (handler.current !== null) {
        handler.current?.close()
      }
    }
  }, [loading])
  useEffect(() => {
    if (configid !== '' && configid !== null) {
      initDetail(configid, setItems, setFile, setBottomFile, setDetailLoading, setFileLoading, setBottomFileLoading).then(null, null)
    }
  }, [configid])
  useEffect(() => {
    if (idno !== undefined && configkey !== undefined) {
      initInfo(idno, configkey, setIscheck, setInfo, () => {
        initConfig(idno, configkey, setConfigid, setArbitratorid, () => { setFileLoading(false); setDetailLoading(false); setBottomFileLoading(false) }).then(null, null)
      }).then(null, null)
    }
  }, [idno, configkey, version])
  useEffect(() => {
    if (form !== null && items.length > 0) {
      form.setFieldsValue({
        items: JSON.parse(JSON.stringify(items)).map((li: ItemSchema, i: number) => {
          const isInput = li.type === '填空'
          const options = li.options.map((o, j) => {
            if (!isInput) {
              return {
                config_optionid: o.id,
                checked: o.isdefault === 1,
                title: o.title,
                placeholder: o.placeholder,
                result: '',
                tooltip: o.tooltip,
                isext: o.isext,
                isdefault: o.isdefault,
                orderno: o.orderno
              }
            } else {
              return {
                config_optionid: o.id,
                placeholder: o.placeholder,
                checked: true,
                orderno: o.orderno
              }
            }
          })
          options.sort((a, b) => a.orderno - b.orderno)
          return {
            config_itemid: li.id,
            type: li.type,
            title: li.title,
            required: li.required,
            config_item_groupid: li.groupid,
            options
          }
        })
      })
    }
  }, [items, form])
  return (
    <div className={style.container}>
      <Mask visible={loading} color='white' opacity={100} />
      {file !== null && <img src={file.url} className={style.pic} onLoad={() => setFileLoading(false)} onError={() => setFileLoading(false)} />}
      {
        !ischeck && (
          <>
            <img src={titlepic} className={style.pic} />
              <Form form={form} onFinish={d => {
                formatData(d)
                if (!validateFn(d.items)) {
                  return undefined
                }
                sumbitHandle(arbitratorid, configid, d.items, setVersion).then(null, null)
              }} footer={<Button block color='primary' size='large' type='submit'>提交</Button>}>
                {
                  items.map((li, i) => <Item data={li} i={i} key={`${li.id}${i}`} formRef={form} />)
                }
              </Form>
          </>
        )
      }
      {
        ischeck && (
          <div className={style.success}>
            <div className={style['succes-info']}>
              {info.map((li, i) => {
                return (
                  <div key={i} className={style.item}>
                    <span className={style['item-label']}>{li.title}：</span>
                    <span>{formatLabel(li.content)}</span>
                  </div>
                )
              })}
            </div>
          </div>
        )
      }
      {bottomfile !== null && <img src={bottomfile.url} className={style.pic} onLoad={() => setBottomFileLoading(false)} onError={() => setBottomFileLoading(false)} />}
    </div>
  )
}

export default Main
